export default __webpack_public_path__ + "static/media/img6.f378a6fe.jpg";